/* global grecaptcha */
'use strict';

module.exports = {
    giftCardBalanceCheckComponent: function () {
        $('body').on('click', '.balance-check-form .btn-save', function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            var siteKey = $('.recaptcha-balance').find('.custom-recaptcha-response').data('sitykey');
            var action = $('.recaptcha-balance').find('.custom-recaptcha-response').data('action');

            if (siteKey && siteKey !== '') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                        $('.recaptcha-balance').find('.custom-recaptcha-response').val(token);
                        $form.submit();
                    });
                });
            } else {
                $form.submit();
            }
        });
    }
};
